import { getEsmColor } from "../../core/utils/esm/getEsmColor"
import "./styles.scss"

export const EscalaLabel = ({ e0, e1, e2, e3, e4, e5, data, showLabel = true, ...props }) => {
  const calcE3 = +e1 + +e2
  const calcE4 = +e1 + +e2 + +e3
  const calcE5 = +e1 + +e2 + +e3 + +e4

  const calcE3Left = e3 <= 15 ? 50 : calcE3
  const calcE4Left = e4 <= 5 ? 95 : calcE4
  const calcE5Left = e5 <= 30 ? 75 : calcE5
  const calcE4Width = e4 <= 5 ? 5 : e4

  return (
    <div className="escala-container-box">
      {Array.isArray(data) && data.length > 0 ? (
        <div className="escala">
          {e1 > 0 && (
            <div
              className={`e1 antooltip ${e1 === "0" ? "e1--radius-total" : ""}`}
              tool-tips={`${e1}%`}
              style={{
                width: `${e1}%`,
                left: 0,
              }}>
              {showLabel && `${e1}%`}
            </div>
          )}
          {e2 > 0 && (
            <div
              className={`e2 antooltip ${e2 <= 30 && "antooltip--last-left-30"}`}
              tool-tips={`${e2}%`}
              style={{
                width: `${e2}%`,
                left: `${e1}%`,
              }}>
              {showLabel && `${e2}%`}
            </div>
          )}
          {e3 > 0 && (
            <div
              className={`e3 antooltip ${
                calcE3Left <= 15
                  ? "antooltip--last-left-30"
                  : calcE3Left > 15 && calcE3Left < 50
                  ? "antooltip--last-left-50"
                  : "antooltip--last-left-95"
              }`}
              tool-tips={`${e3}%`}
              style={{
                width: `${e3}%`,
                left: `${calcE3}%`,
              }}>
              {showLabel && `${e3}%`}
            </div>
          )}
          {e4 > 0 && (
            <div
              className={`e4 antooltip ${
                calcE4Left <= 30
                  ? "antooltip--last-left-30"
                  : calcE4Left > 30 && calcE4Left < 95
                  ? "antooltip--last-left-50"
                  : "antooltip--last-left-95"
              }`}
              tool-tips={`${e4}%`}
              style={{
                width: `${calcE4Width}%`,
                left: `${calcE4Left}%`,
              }}>
              {showLabel && `${e4}%`}
            </div>
          )}
          {e5 > 0 && (
            <div
              className={`e5 ${e5 === "100" ? "e5--radius-total" : ""} antooltip antooltip--last${
                e5 === "100" ? "-left-30" : ""
              } ${
                calcE5Left <= 30
                  ? "antooltip--last-left-30"
                  : calcE5Left > 30 && calcE5Left < 75
                  ? "antooltip--last-left-50"
                  : "antooltip--last-left-95"
              }`}
              tool-tips={`${e5}%`}
              style={{
                width: `${e5}%`,
                left: `${calcE5}%`,
              }}>
              {showLabel && `${e5}%`}
            </div>
          )}
        </div>
      ) : (
        <div className="escala">
          <div className="escala-empty">Não há dados para gerar a escala</div>
        </div>
      )}
      {props.children}
    </div>
  )
}

const calculatePercentage = (totalCount, totalItems) => {
  return Number(((totalCount * 100) / totalItems).toFixed(1))
}

const generateData = (data, valuesToVerify) => {
  const totalItems = data.zaxis.reduce((acc, current) => acc + current.length, 0)

  return valuesToVerify.map((row, i) => {
    let totalCount = 0

    data?.zaxis.forEach((item) => {
      totalCount += item.filter((zValue) => zValue === row?.value).length
    })

    return {
      label: `e${i + 1}`,
      color: getEsmColor(row.value),
      percent: calculatePercentage(totalCount, totalItems),
      count: totalCount,
    }
  })
}

const calculateWidthAndLeft = (percent, basePercent, minPercent, maxPercent) => {
  const calculatedPercent = percent <= minPercent ? maxPercent : percent
  const calculatedLeft = calculatedPercent > minPercent ? basePercent : calculatedPercent

  return { calculatedPercent, calculatedLeft }
}

export const EsmScaleChartLabel = ({ data, valuesToVerify, title }) => {
  const getPercentual = (data, valuesToVerify) => {
    const newData = []

    const totalItems = data.zaxis.reduce((acc, current) => acc + current.length, 0)

    valuesToVerify.map((row, i) => {
      let totalCount = 0

      data?.zaxis.map((item) => {
        totalCount += item.filter((zValue) => zValue == row?.value).length
      })

      newData.push({
        label: `e${[i + 1]}`,
        color: getEsmColor(row.value),
        percent: Number(((totalCount * 100) / totalItems).toFixed(1)),
        count: totalCount,
      })
    })

    return newData
  }

  const percentualData = getPercentual(data, valuesToVerify)

  const e1 = percentualData[0]
  const e2 = percentualData[1]
  const e3 = percentualData[2]
  const e4 = percentualData[3]
  const e5 = percentualData[4]

  const calcE1 = e1?.percent
  const calcE3 = +e1?.percent + +e2?.percent
  const calcE4 = +e1?.percent + +e2?.percent + +e3?.percent
  const calcE5 = +e1?.percent + +e2?.percent + +e3?.percent + +e4?.percent
  const calcE4Left = e4?.percent <= 5 ? 95 : calcE4
  const calcE5Left = e5?.percent > e4?.percent ? calcE5 - 5 : calcE5
  const calcE4Width = e4?.percent <= 5 ? 5 : e4

  const calculateTooltipValues = (calcE5, e4, e3, e2) => ({
    calcTooltip:
      calcE5.toFixed(0) - e4?.percent.toFixed(0) - e3?.percent.toFixed(0) - e2?.percent.toFixed(0),
    calcTooltip4: calcE4.toFixed(0) - e3?.percent.toFixed(0) - 10,
    calcTooltip3: calcE3.toFixed(0) - 8,
    calcTooltip2: 18,
  })

  const calculateHasMoreTwo = (e3, e4, e5, e2, e1) =>
    e3?.percent && e4?.percent && e5?.percent && e2?.percent && e1?.percent

  const calculateCalcWhen2 = (e3, e4, e5, e2, e1) => {
    const hasMoreTwo = calculateHasMoreTwo(e3, e4, e5, e2, e1)
    return hasMoreTwo && e2?.percent > e1?.percent ? 18 : 5
  }

  const { calcTooltip, calcTooltip4, calcTooltip3, calcTooltip2 } = calculateTooltipValues(
    calcE5,
    e4,
    e3,
    e2,
  )
  const hasMoreTwo = calculateHasMoreTwo(e3, e4, e5, e2, e1)
  const calcWhen2 = calculateCalcWhen2(e3, e4, e5, e2, e1)

  return (
    <div className="escala-container-box" style={{ display: "flex", justifyContent: "center" }}>
      {Array.isArray(data.zaxis) && data.zaxis.length > 0 ? (
        <div className="escala" style={{ width: "1000px" }}>
          {e1?.percent > 0 && (
            <div
              className={`e1 antooltip ${
                e1?.percent === "0" ? "e1--radius-total" : ""
              } antooltip-left--col-${calcWhen2}`}
              tool-tips={`Valor: ${e1?.count}`}
              style={{
                backgroundColor: `${e1?.color}`,
                color: `${e1?.color === "#FFF" && "#000"}`,
                border: `${e1?.color === "#FFF" && "1px solid #e7e7e7"}`,
                width: `${calcE1}%`,
                left: 0,
              }}>{`${e1?.percent}% (${e1.count})`}</div>
          )}
          {e2?.percent > 0 && (
            <div
              className={`e2 antooltip antooltip-left--col-${calcWhen2} antooltip-left--col-${
                !hasMoreTwo &&
                e2?.percent.toFixed(0) < e1?.percent.toFixed(0) &&
                e2?.percent.toFixed(0) < 5
                  ? "-left"
                  : ""
              }`}
              tool-tips={`Valor: ${e2?.count}`}
              style={{
                backgroundColor: `${e2?.color}`,
                color: `${e2?.color === "#FFF" && "#000"}`,
                border: `${e2?.color === "#FFF" && "1px solid #e7e7e7"}`,
                width: `${e2?.percent}%`,
                left: `${calcE1}%`,
              }}>{`${e2?.percent}% (${e2.count})`}</div>
          )}
          {e3?.percent > 0 && (
            <div
              className={`e3 antooltip antooltip-left--col-${calcTooltip3}`}
              tool-tips={`Valor: ${e3?.count}`}
              style={{
                backgroundColor: `${e3?.color}`,
                color: `${e3?.color === "#FFF" && "#000"}`,
                border: `${e3?.color === "#FFF" && "1px solid #e7e7e7"}`,
                width: `${e3?.percent}%`,
                left: `${calcE3}%`,
              }}>{`${e3?.percent}% (${e3.count})`}</div>
          )}
          {e4?.percent > 0 && (
            <div
              className={`e4 antooltip antooltip-left--col-${calcTooltip4}`}
              tool-tips={`Valor: ${e4?.count}`}
              style={{
                backgroundColor: `${e4?.color}`,
                color: `${e4?.color === "#FFF" && "#000"}`,
                border: `${e4?.color === "#FFF" && "1px solid #e7e7e7"}`,
                width: `${calcE4Width}%`,
                left: `${calcE4Left}%`,
              }}>{`${e4?.percent}% (${e4.count})`}</div>
          )}
          {e5?.percent > 0 && (
            <div
              className={`e5 antooltip ${
                e5?.percent === "100" ? "e5--radius-total" : ""
              } antooltip-left--col-${calcTooltip} antooltip-left--col-${
                calcTooltip < e4?.percent.toFixed(0) && e5?.percent.toFixed(0) < 5 ? "-left" : ""
              }`}
              tool-tips={`Valor: ${e5?.count}`}
              style={{
                backgroundColor: `${e5?.color}`,
                color: `${e5?.color === "#FFF" && "#000"}`,
                border: `${e5?.color === "#FFF" && "1px solid #e7e7e7"}`,
                width: `${e5?.percent}%`,
                left: `${calcE5Left}%`,
              }}>{`${e5?.percent}% (${e5.count})`}</div>
          )}
        </div>
      ) : (
        <div className="escala">
          <div className="escala-empty">Não há dados para gerar a escala</div>
        </div>
      )}
    </div>
  )
}

export const EscalaLabel2 = ({ e0, e1, e2, e3, e4, e5, ...props }) => {
  return (
    <div className="escala-container-box">
      <div className="escala escala2">
        <div className="e0">{!isNaN(e0) ? e0 : 0}</div>
        <div className="e1">{!isNaN(e1) ? e1 : 0}</div>
        <div className="e2">{!isNaN(e2) ? e2 : 0}</div>
        <div className="e3">{!isNaN(e3) ? e3 : 0}</div>
        <div className="e4">{!isNaN(e4) ? e4 : 0}</div>
        <div className="e5">{!isNaN(e5) ? e5 : 0}</div>
      </div>
      {props.children}
    </div>
  )
}
